export const ROOT = '/';
export const APP = '/app';

/**
 * OPEN ROUTES
 */
export const LOGIN = '/';
export const FORGOT_PASSWORD = '/forgot-password';
export const RESET_PASSWORD = '/reset-password/:token';
export const SALES_WEB_FAQS = `/faqs`;
export const SALES_MOBILE_FAQS = `/mobile/faqs`;

export const OBX_WEB_FAQS = `/obx/web/faqs`;
export const OBX_MOBILE_FAQS = `/obx/mobile/faqs`;

export const HO_WEB_FAQS = `/ho/web/faqs`;
export const HO_MOBILE_FAQS = `/ho/mobile/faqs`;

export const LOGOUT = '/logout';
export const NO_SERVER = `/noserver`;
export const NO_INTERNET = `/nointernet`;

export const COMMON_SETTING = `${APP}/settings`;

export const PROBLEMS_REPORTED = '/report-a-problem';
export const PROBLEMS_REPORTED_DETAILS = `${PROBLEMS_REPORTED}/detail`;
export const PROBLEMS_REPORTED_DETAILS_ROUTE = `${PROBLEMS_REPORTED}/detail/:id`;

// LEADS MANAGMENT ROUTES

export const DASHBOARD = `${APP}/dashboard`;
export const LEADS = `${APP}/leads`;
export const ACTIVITY_LOGS = `${APP}/activity-logs`;
export const LEAD_ARCHIVED = `${APP}/leads/archived`;
export const LEAD_CREATE = `${APP}/leads/create`;
export const LEAD_DETAIL = `${APP}/leads/detail/:id`;
export const LEAD_ARCHIVED_DETAIL = `${APP}/leads/archived/detail/:id`;

export const COMMON_SETTING_PREFERENCES = `${COMMON_SETTING}?activeTab=preferences`;

export const PROFILE = `${APP}/settings/profile`;

export const NOTIFICATIONS = `${APP}/notifications`;

//QA testing route
export const QA_MODULE_ROUTE = `${APP}/qaModuleTest`;

export const LEAD_SYSTEM_USERS = `${APP}/leads/system-users`;
export const LEAD_EXPORTED_LEADS = `${APP}/leads/exported`;
